import { InjectionToken } from '@angular/core';

import { DoodEntityModel } from '@core/models/entity.model';

/** Runtime VM emitted by `ShopAroundListBodyBlock` data sources. */
export type ShopAroundListBodyBlockViewModel = {
  /** `undefined` while loading; an array (possibly empty) once loaded. */
  shops: DoodEntityModel[] | undefined;
  wantedAt: Date | null;
};

export const SHOP_AROUND_LIST_BODY_BLOCK_LOADING_VM: ShopAroundListBodyBlockViewModel = {
  shops: undefined,
  wantedAt: null,
};

export interface ShopAroundListBodyBlockDataSource {
  readonly vm$: import('rxjs').Observable<ShopAroundListBodyBlockViewModel>;
}

export const SHOP_AROUND_LIST_BODY_BLOCK_DATA_SOURCE =
  new InjectionToken<ShopAroundListBodyBlockDataSource>('SHOP_AROUND_LIST_BODY_BLOCK_DATA_SOURCE');
